var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "table-wrapper" }, [
    _c("table", { staticClass: "data-table text-sm w-full font-outfit" }, [
      _c("thead", [
        _c(
          "tr",
          [
            _c(
              "th",
              {
                staticClass:
                  "bg-lightBlue px-2 py-2 border-b-1 border-gray-200 text-left font-medium",
              },
              [
                _c("label", { staticClass: "custom-checkbox" }, [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    domProps: { checked: _vm.areAllSelected },
                    on: { change: _vm.handleSelectAll },
                  }),
                  _c("span", { staticClass: "icon-checked" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "11",
                          height: "9",
                          viewBox: "0 0 11 9",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M1.91308 4.03516H1.91326C1.99256 4.03525 2.07081 4.05331 2.14213 4.08798C2.21341 4.12262 2.27591 4.17295 2.32497 4.2352L1.91308 4.03516ZM1.91308 4.03516H1.09394C0.890308 4.03516 0.776602 4.26975 0.902321 4.4292L0.902371 4.42927L4.11214 8.49567L4.11218 8.49573C4.32247 8.76188 4.72568 8.76114 4.93667 8.49617L4.93708 8.49566L10.6597 1.24398C10.6598 1.24378 10.66 1.24358 10.6602 1.24338C10.7884 1.08295 10.6699 0.85 10.4689 0.85H9.6498C9.48941 0.85 9.33668 0.9235 9.2376 1.05044C9.23751 1.05055 9.23742 1.05066 9.23734 1.05077L4.52403 7.02157M1.91308 4.03516L4.52403 7.02157M4.52403 7.02157L2.32506 4.23531L4.52403 7.02157Z",
                            fill: "white",
                            stroke: "white",
                            "stroke-width": "0.3",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
            _vm._l(_vm.headers, function (header) {
              return _c(
                "th",
                {
                  key: header.text,
                  staticClass:
                    "bg-lightBlue px-2 py-2 border-b-1 border-gray-200 text-left font-medium",
                },
                [_vm._v(" " + _vm._s(header.text) + " ")]
              )
            }),
          ],
          2
        ),
      ]),
      _c(
        "tbody",
        [
          _vm._l(_vm.data, function (item, index) {
            return _c("tr", { key: index, staticClass: "message-unread" }, [
              _c(
                "td",
                {
                  staticClass:
                    "px-2 py-2 border-b-1 border-gray-200 font-normal",
                },
                [
                  _c("label", { staticClass: "custom-checkbox" }, [
                    _c("input", {
                      attrs: { type: "checkbox" },
                      domProps: { checked: _vm.isSelected(item) },
                      on: {
                        change: function ($event) {
                          return _vm.handleRowCheckboxChange(item)
                        },
                      },
                    }),
                    _c("span", { staticClass: "icon-checked" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "11",
                            height: "9",
                            viewBox: "0 0 11 9",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M1.91308 4.03516H1.91326C1.99256 4.03525 2.07081 4.05331 2.14213 4.08798C2.21341 4.12262 2.27591 4.17295 2.32497 4.2352L1.91308 4.03516ZM1.91308 4.03516H1.09394C0.890308 4.03516 0.776602 4.26975 0.902321 4.4292L0.902371 4.42927L4.11214 8.49567L4.11218 8.49573C4.32247 8.76188 4.72568 8.76114 4.93667 8.49617L4.93708 8.49566L10.6597 1.24398C10.6598 1.24378 10.66 1.24358 10.6602 1.24338C10.7884 1.08295 10.6699 0.85 10.4689 0.85H9.6498C9.48941 0.85 9.33668 0.9235 9.2376 1.05044C9.23751 1.05055 9.23742 1.05066 9.23734 1.05077L4.52403 7.02157M1.91308 4.03516L4.52403 7.02157M4.52403 7.02157L2.32506 4.23531L4.52403 7.02157Z",
                              fill: "white",
                              stroke: "white",
                              "stroke-width": "0.3",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "td",
                {
                  staticClass:
                    "px-2 py-2 border-b-1 border-gray-200 flex flex-row",
                },
                [
                  _c(
                    "RouterLink",
                    {
                      attrs: {
                        to: `/company_database/contractors/${item?.id}/about`,
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-storm-gray text-sm p-1 font-medium rounded-full block border border-gray-300 bg-white borderCard",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-row items-center",
                              attrs: {
                                name: "imageAvatar",
                                image: item?.user?.avatar,
                              },
                            },
                            [
                              item?.user?.avatar !== null
                                ? _c("S3Image", {
                                    class: [_vm.defaultImageClasses],
                                    attrs: { s3FileKey: item?.user?.avatar },
                                  })
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-xs font-medium text-white justify-center uppercase flex items-center rounded-full bg-white w-6 h-6 mr-2",
                                  class: _vm.getAvatrClass,
                                  style: _vm.bgStyle(item),
                                },
                                [_vm._v(" " + _vm._s(_vm.initial(item)) + " ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-storm-gray text-sm font-medium",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.user.given_name) +
                                      " " +
                                      _vm._s(item.user.family_name) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "td",
                { staticClass: "px-2 py-2 border-b-1 border-gray-200" },
                [_vm._v(" " + _vm._s(item?.user?.private_data?.email) + " ")]
              ),
            ])
          }),
          _vm.data.length === 0 ? _c("tr", [_vm._m(0)]) : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", { staticClass: "empty-state", attrs: { colspan: "9" } }, [
      _c("div", { staticClass: "empty-state-text" }, [_vm._v("No resources")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }